import { __awaiter } from "tslib";
import axios from 'axios';
import { API_STAGES, API_URLS } from '../api';
import query from './query';
const createTransaction = (params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { sandbox } = params;
        const result = yield axios.post(sandbox ? API_URLS.local : API_URLS.prod, {
            query,
            variables: JSON.stringify(params),
        }, {
            headers: {
                'Content-Type': 'application/json',
                'X-Stage': sandbox ? API_STAGES.local : API_STAGES.prod,
            },
        });
        if (result.data === undefined) {
            throw Error(JSON.stringify(result));
        }
        return result.data;
    }
    catch (ex) {
        const error = ex;
        if (error.response) {
            console.log(`Error: ${JSON.stringify(error.response.data)}`);
        }
        throw ex;
    }
});
export default createTransaction;
//# sourceMappingURL=createTransaction.js.map